import { cn } from '@/utils/tailwind-util';

type SpinnerSizeProps = 'sm' | 'md' | 'lg';
interface Props {
  styles?: string;
  size?: SpinnerSizeProps;
}

const SpinnerSizeCss = (size: Props['size']) => {
  if (size === 'sm') {
    return 'w-5 h-5';
  } else if (size === 'md') {
    return 'w-10 h-10';
  }

  return 'w-20 h-20';
};

const Spinner: React.FC<Props> = ({ size = 'lg', styles }) => (
  <div
    className={cn(
      'animate-[spin-animation_1s_linear_infinite] fixed z-1000 top-0 left-0 right-0 bottom-0 m-auto border-[5px] border-solid border-[#ebefff] border-t-[#98a7f6] rounded-[50%]',
      SpinnerSizeCss(size),
      styles
    )}
  />
);

export default Spinner;
